import { BaseUnit } from './BaseUnit';
import { Enemy } from '../Enemy';
import { GameScene } from '../../scenes/GameScene';
import { CLUB_SWINGER, WALL_X, WALL_WIDTH } from '../../config';
import { StickFigureGraphics } from '../../rendering/StickFigureGraphics';

export class ClubSwinger extends BaseUnit {
    private attackTimer: number = 0;
    private swingPhase: number = 0;

    constructor(scene: Phaser.Scene, x: number, y: number, slotIndex: number) {
        super(scene, x, y, slotIndex);
        this.draw();
    }

    getDamage(): number {
        const perUnitDamage = Math.round(CLUB_SWINGER.baseDamage * this.bonusDamageMult * this.globalDamageMult);
    return perUnitDamage * this.stackCount;
    }

    getAoeRadius(): number {
        return CLUB_SWINGER.aoeRadius + this.bonusAoeRadius;
    }

    getMaxTargets(): number {
        return CLUB_SWINGER.maxTargets + this.bonusMaxTargets;
    }

    update(time: number, delta: number, enemies: Enemy[]): void {
        // Animate swing
        if (this.swingPhase > 0) {
            this.swingPhase -= delta * 0.004;
            if (this.swingPhase < 0) this.swingPhase = 0;
        }

        // Attack enemies that are at the wall (attacking)
        this.attackTimer -= delta;
        if (this.attackTimer <= 0) {
            const allTargets = this.findEnemiesAtWall(enemies);
            if (allTargets.length > 0) {
                this.attackTimer = this.getEffectiveAttackInterval(CLUB_SWINGER.attackInterval);
                this.swingPhase = 1;
                // Limit to maxTargets, prioritizing closest enemies
                const targets = allTargets.slice(0, this.getMaxTargets());
                this.attackEnemies(targets);
            } else {
                this.attackTimer = 0;
            }
        }

        this.draw();
    }

    private findEnemiesAtWall(enemies: Enemy[]): Enemy[] {
        const wallStopX = WALL_X + WALL_WIDTH + 20;
        const inRange: Enemy[] = [];

        for (const enemy of enemies) {
            if (enemy.isDead || !enemy.isAttacking) continue;
            if (enemy.isBurrowed || enemy.isGoblin) continue;

            // Check if enemy is at the wall (melee distance)
            const dx = enemy.x - wallStopX;

            if (dx <= CLUB_SWINGER.range) {
                inRange.push(enemy);
            }
        }

        return inRange;
    }

    private attackEnemies(targets: Enemy[]): void {
        const damage = this.getDamage();
        for (const enemy of targets) {
            const isDead = enemy.takeDamage(damage);
            if (isDead) {
                if (this.scene instanceof GameScene) {
                    this.scene.processEnemyKill(enemy);
                }
            } else if (this.disarmDuration > 0) {
                enemy.applyDisarm(this.disarmDuration);
            }
        }
    }

    draw(): void {
        if (this.swingPhase <= 0) {
            this.sprite.setTexture('friendly_club_idle');
        } else {
            let frame = Math.floor((1 - this.swingPhase) * 8);
            if (frame < 0) frame = 0;
            if (frame > 7) frame = 7;
            this.sprite.setTexture(`friendly_club_${frame}`);
        }

        this.graphics.clear();
        if (this.level > 1) {
            this.graphics.fillStyle(0xffd700, 1);
            for (let i = 0; i < Math.min(this.level - 1, 5); i++) {
                this.graphics.fillCircle(this.x - 8 + i * 4, this.y + 16, 1.5);
            }
        }
    }
}
